module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-dune-timber-hamilton-1.9ef71e6f.jpg";